import AryLoadingAnimation from 'framework/desktop/AryLoadingAnimation';
import React, { useEffect, useRef } from 'react';
import { useStore } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import authService from './AuthorizeService';

const LoginCallbackHandler = () => {
  const navigate = useNavigate();
  const reduxStore = useStore();
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;

    called.current = true;
    authService.clearUserInfoCache();

    authService.fetchRefreshToken(navigate, reduxStore.dispatch);
    sessionStorage.removeItem('login_lock');
  }, []);

  return <AryLoadingAnimation />;
};

export default LoginCallbackHandler;
